<template>
<span>
    <v-toolbar flat color="white">
        <v-toolbar-title class="lime--text lighten-1">Gerenciar Tipos de Conteúdo</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <template>
            <v-btn color="blue-grey darken-2" dark class="mb-1 mr-2" @click.prevent="atualizarDados">
                <v-icon dark>sync</v-icon>Atualizar
            </v-btn>
            <v-btn color="success" dark class="mb-1" :to="{name: 'contentTypes.add'}">
                <v-icon class="mdi mdi-plus"></v-icon>Adicionar Novo Tipo</v-btn>
        </template>
    </v-toolbar>

    <v-card>
        <v-card-title>
            <v-text-field v-model="search" append-icon="search" label="Localizar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="loadContentTypes" :search="search" :rowsPerPageItems="rowsPerPageItems">

            <template v-slot:[`item.cont_ty_status`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.cont_ty_status" @change="onChangeEventHandlertSatus(item.cont_ty_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.acoes`]="{ item }">
                <v-tooltip top color="blue white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="blue lighten-1" @click.prevent="editContentType(item)" v-on="on">
                            <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar</span>
                </v-tooltip>

                <v-tooltip top color="red white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="red lighten-1" @click.prevent="deleteContentType(item)" v-on="on">
                            <v-icon dark class="mdi mdi-delete"></v-icon>
                        </v-btn>
                    </template>
                    <span>Excluir</span>
                </v-tooltip>

            </template>

            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">Voce procurou por "{{ search }}" nenhum item localizado.</v-alert>
            </template>
        </v-data-table>
    </v-card>
</span>
</template>

<script>
import {
    URL_BASE
} from "../../../config/configs";

export default {
    created() {
        this.$store.dispatch("loadContentTypes");
    },
    computed: {
        loadContentTypes() {
            if (this.$store.state.contenttypes.items.data == null) return [];

            return this.$store.state.contenttypes.items.data;
        }
    },
    name: "ContentTypeComponent",
    data() {
        return {
            search: "",
            rowsPerPageItems: [
                10,
                20,
                30,
                {
                    text: "$vuetify.dataIterator.rowsPerPageAll",
                    "10": -1
                }
            ],
            headers: [{
                    sortable: false,
                    text: "Nome",
                    value: "cont_ty_nome"
                },
                {
                    sortable: false,
                    text: "Descrição",
                    value: "cont_ty_descricao"
                },
                {
                    sortable: false,
                    text: "Status",
                    value: "cont_ty_status"
                },
                {
                    text: "Ações",
                    align: "center",
                    sortable: false,
                    value: "acoes"
                }
            ],
            contentType: [],
            base_url: URL_BASE
        };
    },
    methods: {
        atualizarDados() {
            this.$store.dispatch("loadContentTypes");
        },
        editContentType(item) {
            this.$router.push({
                name: "contentTypes.edit",
                params: {
                    cont_ty_id: item.cont_ty_id
                }
            });
        },
        deleteContentType(item, index) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Todos as Seções, Categorias e Conteúdos desse tipo serão excluídos",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#D32F2F",
                cancelButtonColor: "#1976D2",
                confirmButtonText: "Sim, Exclua!"
            }).then(result => {
                if (result.value) {
                    this.$store
                        .dispatch("destroyContentType", item.cont_ty_id)
                        .then(response => {
                            if (response) {
                                this.$swal({
                                    position: "center",
                                    type: "success",
                                    title: "Sucesso",
                                    text: "Dados excluídos com sucesso",
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                                this.atualizarDados();
                            } else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: "Opssss!",
                                    text: "Erro ao excluir dados",
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Opssss!",
                                text: "Algo errado aconteceu!",
                                showConfirmButton: true,
                                timer: 6000
                            });
                        });
                }
            });
        },
        onChangeEventHandlertSatus(cont_ty_id, value) {
            this.$store
                .dispatch("updateContentTypesStatus", {
                    cont_ty_id: cont_ty_id,
                    status: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Sucesso",
                        text: "Status atualizado com sucesso",
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Opssss!",
                        text: "Erro ao atualizar status",
                        showConfirmButton: true,
                        timer: 6000
                    });
                });
        }
    }
};
</script>

<style scoped>
</style>
